import { getSlateColorToken } from "@faire/retailer-shared/SlateMappings/getSlateColorToken";
import { IFaireIcon } from "@faire/web-api/indigofair/data/IFaireIcon";
import { Row } from "@faire/web/slate/Layout";
import { getSlateIcon } from "@faire/web/slate/SlateMappings/getSlateIcon";
import { NoTranslate } from "@faire/web/ui/lib/localization";
import classNames from "classnames";
import React from "react";

import { LoadableTypography } from "@faire/retailer/components/GhostLoading/LoadableTypography";

// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { ProductClickForSearchPageParameters } from "../ComposableProductTile/__internal__/__internal__/productTileActions/useOnProductClickForSearchPage";

import { SearchMarketplaceProductBrandLink } from "./__internal__/SearchMarketplaceProductBrandLink";
import * as styles from "./brandNameText.css";

interface IBrandNameTextProps {
  brandToken: string | undefined;
  brandName: string | undefined;
  brandIcon?: IFaireIcon | undefined;
  isLoaded: boolean;
  trackingParams?: ProductClickForSearchPageParameters;
  onBrandLinkClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  generateBrandUrl?: (brandToken: string) => string | undefined;
}

export const BrandNameText: React.FC<IBrandNameTextProps> = ({
  brandToken,
  brandName,
  brandIcon,
  isLoaded,
  trackingParams,
  onBrandLinkClick,
  generateBrandUrl,
}) => {
  const BrandIcon = getSlateIcon(brandIcon);
  return brandToken ? (
    <Row className={classNames(styles.makerName)} justify="space-between">
      <SearchMarketplaceProductBrandLink
        brandToken={brandToken}
        trackingParams={trackingParams}
        onBrandLinkClick={onBrandLinkClick}
        generateBrandUrl={generateBrandUrl}
      >
        <Row align="center" gap="1/4x">
          {brandIcon ? (
            <BrandIcon
              fontSize="12px"
              color={getSlateColorToken(brandIcon.color_token)}
              titleAccess=""
            />
          ) : null}
          <LoadableTypography
            isLoaded={isLoaded}
            variant="paragraphSansRegular"
            maxLines={1}
          >
            <NoTranslate>
              <ResponsiveBrandName brandName={brandName ?? ""} />
            </NoTranslate>
          </LoadableTypography>
        </Row>
      </SearchMarketplaceProductBrandLink>
    </Row>
  ) : null;
};

const ResponsiveBrandName = ({ brandName }: { brandName: string }) => {
  return <span>{brandName}</span>;
};
